'use client';

import type { ReactNode } from 'react';
import { Text } from '@skin-seoul/design-system';
import type { SafeLinkProps } from '@/components/ui/SafeLink';
import { SafeLink } from '@/components/ui/SafeLink';
import { CLASSNAME } from '@skin-seoul/service';
export const MenuItem = ({
  children,
  ...rest
}: {
  children: ReactNode;
} & SafeLinkProps) => {
  return <Text _hover={{
    color: 'neutral.500'
  }} asChild color="neutral.700" textStyle="paragraph.small" transition="color 0.3s" data-sentry-element="Text" data-sentry-component="MenuItem" data-sentry-source-file="MenuItem.tsx">
      <SafeLink {...rest} textDecoration="none" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="SafeLink" data-sentry-source-file="MenuItem.tsx">
        {children}
      </SafeLink>
    </Text>;
};